import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountGuard } from './core/guards/account.guard';
import { KeineBerechtigungComponent } from './shared/components/keine-berechtigung/keine-berechtigung.component';
import { UpsComponent } from './shared/components/ups/ups.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'odbs',
        pathMatch: 'full',
    },
    {
        path: 'odbs',
        canActivate: [AccountGuard],
        loadChildren: () => import('src/app/odbs/odbs.module').then((m) => m.OdbsModule),
    },
    {
        path: 'keine-berechtigung',
        component: KeineBerechtigungComponent,
    },
    {
        path: 'ups',
        component: UpsComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            enableTracing: false,
            scrollPositionRestoration: 'top',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
